import { useEffect, useState } from 'react';
import { ListWorkPackageDto } from '@codefluegel/zeta-change-typescript-client';
import { usePspPhaseApiFactory } from '../ApiClient';
import { useProjectStore } from '../store/projectStore';

function useWorkPackageName(workPackage: ListWorkPackageDto | undefined) {
  const [workPackageName, setWorkPackageName] = useState('');
  const { pspPhases } = useProjectStore();
  const pspPhaseApi = usePspPhaseApiFactory();

  useEffect(() => {
    if (!workPackage) return;
    (async () => {
      const phase = pspPhases.find(
        p => Number(p.id) === Number(workPackage.navPhasePspId),
      );
      if (!phase) return;
      try {
        if (workPackage.areaPsp) {
          const areaPspStr = String(workPackage.areaPsp).padStart(2, '0');
          const { data: workPackages } =
            await pspPhaseApi.pspPhasesControllerFindAllPspWorkPackages({
              pspId: phase.id,
              areaId: areaPspStr,
            });
          const foundName = workPackages.find(
            wP => wP.id === workPackage.workPackagePspId,
          )?.name;
          setWorkPackageName(`${phase.name} - ${foundName || ''}`);
        }
      } catch (e) {
        console.warn('cannot find combination', e);
      }
    })();
  }, [workPackage, pspPhases, pspPhaseApi]);

  return workPackageName;
}

export default useWorkPackageName;
